module.exports = __webpack_public_path__ + "img/vlightlogo.f5fe1ee1.png";